import ReactDOM from 'react-dom/client'
import React from 'react'
import App from './app/App'
import './i18n'

import 'react-toastify/dist/ReactToastify.css'
import './styles/typographies.css'
import './styles/staging.css'
import './styles/global.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
